// Lazyload library - https://github.com/verlok/lazyload 
// leverages the IntersectionObserver API

const lazyloadinstance = (function() {
	console.log('lazyload');
	if (window.location.href.indexOf('ed=1') === -1) {
		var callback_enter = function (element) {
			element.classList.add('loaded');
		};
		var callback_reveal = function(element) {
			element.classList.add('loaded');
		};

		var lazyLoadInstance = new LazyLoad({
			elements_selector: ".lazy",
			threshold: 0,
			callback_enter: callback_enter,
			callback_reveal: callback_reveal
		});
	} else {
		var lazyimages = Array.prototype.slice.call(document.querySelectorAll('.lazy'));
		console.log(lazyimages);
		[...lazyimages].forEach((img) => {
			let bgsrc = img.getAttribute('data-bg');
			let imgsrc = img.getAttribute('data-src');

			if (bgsrc) {
				img.style.backgroundImage = bgsrc;
				img.classList.add('loaded');
			} else if(imgsrc) {
				img.setAttribute('src', imgsrc);
				img.classList.add('loaded');
			}
		});
	}
});
lazyloadinstance();



